import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BaseDialogProps, DialogModel, ShowDialogPayload } from '../types'
import { getComponentNameFromImportFactory } from '../utils'

export const name = 'dialogs'

export type DialogsState = DialogModel[]

const initialState: DialogsState = []

const reducers = {
  pushDialog: (state: DialogsState, action: PayloadAction<ShowDialogPayload>) => {
    const name = action.payload.name ?? getComponentNameFromImportFactory(action.payload.factory)
    if (!name) {
      console.warn(`Unable determine dialog name`)
      return
    }

    const index = state.findIndex((dialog) => dialog.name === name)
    if (index !== -1) {
      console.warn(`Dialog ${name} is already opened`)
      return
    }

    state.push({
      dialogProps: action.payload.dialogProps || {},
      factory: action.payload.factory,
      name
    })
  },
  closeDialog: (state: DialogsState, action: PayloadAction<string>) => {
    const index = state.findIndex((dialog) => dialog.name === action.payload)

    state.splice(index, 1)
  }
}

export const dialogsSlice = createSlice({
  name,
  initialState,
  reducers
})

// This is needed, as `createSlice` removes any generics from type definition of reducer, so we
// need to manually "retype" action creator for our needs.
export function pushDialog<PropsT extends BaseDialogProps>(payload: ShowDialogPayload<PropsT>) {
  return dialogsSlice.actions.pushDialog(payload as ShowDialogPayload<BaseDialogProps>)
}
export default dialogsSlice.reducer

export const { closeDialog, pushDialog: _pushDialog } = dialogsSlice.actions
